import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, FormField, Link, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { parse } from 'date-fns';
import { format } from 'date-fns/format';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

export const SystemSecurityAPIKeysPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")
    const [keys, setKeys] = useState<any[]>([])
    const { navigate } = useRouter();
    const { menu, idAirport } = useGlobalState();


    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            handleGetApiKeys();
        }, 500);
        return () => clearTimeout(timer);
    }, [idAirport]);
    const handleGetApiKeys = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/security/apikeys/list',
                },
                body: JSON.stringify({}),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                setKeys(dataWeb.keys);
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };
    useEffect(() => {
        handleGetApiKeys();
    }, []);


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <Button onClick={() => navigate("system/security/apikeys.add")} variant="normal">Generar</Button>
                    } description="Credenciales de acceso a los EndPoints">API Keys</Header>
                    <Table
                        items={keys}
                        columnDefinitions={[
                            { id: 'key', header: 'ID', cell: item => item.idApiKey },
                            { id: 'description', header: 'Descripción', cell: item => <Link href={`#system/security/apikeys.edit?id=${item.idApiKey}`}>{item.description}</Link> },
                            {
                                id: 'createdAt', header: 'Creado el', cell: item => <FormField label={format(parse(item.dateCreated, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")}>
                                    {format(parse(item.dateCreated, "dd-MM-yyyy HH:mm", new Date()), "HH:mm")}
                                </FormField>
                            },
                            { id: 'isActive', header: 'Estado', cell: item => item.isActive ? 'Activo' : 'Inactivo' },
                        ]}
                        variant="borderless"
                        stickyHeader
                        empty={
                            <Box
                                margin={{ vertical: "xs" }}
                                textAlign="center"
                                color="inherit"
                            >
                                <SpaceBetween size="m">
                                    <b>No existen Api Keys</b>
                                </SpaceBetween>
                            </Box>
                        }

                    />
                </SpaceBetween>
            }
        />
    )
};
